import React from 'react';

const yearOfDate = new Date().getFullYear();

const Footer = () => {
  return (
    <div className='text-center p-4'>
      <span>Copyright &copy; {yearOfDate} powered by tango</span>
    </div>
  );
};

export default Footer;
